import { render, staticRenderFns } from "./LOCATION.vue?vue&type=template&id=453a8f0a&"
import script from "./LOCATION.vue?vue&type=script&lang=js&"
export * from "./LOCATION.vue?vue&type=script&lang=js&"
import style0 from "./LOCATION.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports